import styled from '@2pulse/responsive';
import { withComponents } from '@app/helpers';
import { normalize } from '@app/helpers';
import { row } from '@app/style';

const Label = styled.Text<{ isActive?: boolean, small?: boolean, sub?: boolean }>(({ theme, props }) => ({
  fontFamily: 'Work Sans',
  fontSize: props.small ? normalize(16) : props.sub ? normalize(18) : normalize(20),
  fontWeight: '500',
  color: props.isActive ? '#0089C8' : theme.colors.oxfordblue,
}));

const Tabs = styled.View({
  ...row,
  alignItems: 'flex-end',
});

export const Tab = withComponents(styled.TouchableOpacity<{ isActive?: boolean, small?: boolean, sub?: boolean }>(({ props }) => ({
  padding: props.small ? normalize(13) : props.sub ? normalize(13) : normalize(21),
  paddingVertical: props.small ? normalize(8) : undefined,
  borderRadius: 8,
  opacity: (!props.isActive && props.small) ? 0.5 : 1,
  backgroundColor: props.isActive ? '#C7E4F2' : 'transparent',
})), {
  Tabs,
  Label,
});
